import { tl } from '@doda/common/src/utils/adobeAnalyticsUtil';

// 動画再生時にaaTagを発火
export const submitAaTag = (ratio: string, jid: string) => {
  tl('Video_Track', {
    linkTrackVars:
      'channel,prop1,prop4,prop5,prop32,prop68,prop69,prop75,eVar57,eVar68,eVar77,eVar78,eVar79,eVar82,eVar100,eVar107,eVar116,eVar119,eVar120,eVar121,eVar127',
    linkTrackEvents: 'event98',
    events: 'event98',
    eVar119: 'prime',
    eVar120: 'prime',
    eVar121: ratio,
    prop32: jid,
  });
};
